import { MODULE } from "@/config/modules";
import { CompanyModule } from "./company-module";
import { ElectronischeFacturatieMetaData } from "./module-electronische-facturatie";

export class Module {
	id:MODULE | number = 0;
	name:string = "";
	price:number = 0;
	permanentPrice:number = 0;

	constructor(data:any = null) {
		if (!data) return;
		this.id = data.ID;
		this.name = data.Name;
		this.price = data.Price;
		this.permanentPrice = data.PermanentPrice;
	}

	getJSON() {
		return {
			ID: this.id,
			Name: this.name,
			Price: this.price,
			permanentPrice: this.permanentPrice,
		};
	}

	toCompanyModule():CompanyModule{
		let metadata:any = null;
		if (this.id == MODULE.ELECTRONISCHE_FACTURATIE) {
			metadata = ElectronischeFacturatieMetaData.createDefault();
		}
		return new CompanyModule({ID: this.id, Name: this.name, MetaData: metadata});
	}
}